import {ReviewsSection_ReviewSummary} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {FONT_SIZES, Text, UnstyledButton} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {OverallRating} from '../Sections/OverallRating';
import {ReviewsActionStatement} from '../Sections/ReviewsActionStatement';
import {ReviewsFlyout} from '../Sections/ReviewsFlyout';
import {ReviewsUserReview} from '../Sections/ReviewsUserReview';
import {useReviewsFlyoutStateManager} from '../utils/useReviewsFlyoutStateManager';

interface Props {
  shouldShowUserReviews: boolean;
  shouldShowUserReviewsSlider: boolean;
  trackAllReviewsButtonFeatureClick: () => void;
  showQualityAndFitLabels?: boolean;
  shouldAlignRightReviewsButton: boolean;
}

export const ReviewsSectionStream: FC<ReviewsSection_ReviewSummary & Props> = ({
  overallRating,
  overallStarRating,
  reviewCount,
  showcaseReviews,
  trackAllReviewsButtonFeatureClick,
  shouldShowUserReviews,
  shouldShowUserReviewsSlider,
  showQualityAndFitLabels,
  actionStatements,
  shouldAlignRightReviewsButton,
}) => {
  const {t} = useTranslation();
  const {open} = useReviewsFlyoutStateManager();

  const openAllReviews = () => {
    open();
    trackAllReviewsButtonFeatureClick();
  };

  return (
    <>
      <OverallRating
        overallStarRating={overallStarRating}
        overallRating={overallRating}
        reviewCount={reviewCount}
        reduceBottomMargin={showQualityAndFitLabels}
      />
      {showQualityAndFitLabels && actionStatements.length > 1 && (
        <ReviewsActionStatement actionStatements={actionStatements} />
      )}
      {shouldShowUserReviews && showcaseReviews.length > 1 && (
        <ReviewsContainer>
          <ReviewsUserReview
            showcaseReviews={showcaseReviews}
            showSlider={shouldShowUserReviewsSlider}
          />
        </ReviewsContainer>
      )}
      {showcaseReviews.length > 1 && (
        <>
          <ShowAllReviewsButton
            alignRight={shouldAlignRightReviewsButton}
            onClick={openAllReviews}
            data-testid="showAllReviewsButton"
            aria-label={undefined}
          >
            <Text weight={shouldShowUserReviews ? 'bold' : undefined}>
              {t('Show all customer reviews >')}
            </Text>
          </ShowAllReviewsButton>
          <ReviewsFlyout
            reviewCount={reviewCount}
            overallRating={overallRating}
            overallStarRating={overallStarRating}
            showcaseReviews={showcaseReviews}
            reduceBottomMargin
          />
        </>
      )}
    </>
  );
};

const ReviewsContainer = styled.div`
  margin-bottom: 1rem;
  margin-top: 0.5rem;
`;

const ShowAllReviewsButton = styled(UnstyledButton)<{
  alignRight: boolean;
}>`
  font-size: ${FONT_SIZES.px14};
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;

  ${({alignRight}) =>
    alignRight &&
    css`
      margin-right: 0;
      padding-right: 10px;
    `}
`;
